import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { getLegalUI } from "@/i18n/legal";

export function CookieConsent() {
  const { lang } = useLang();
  const ui = getLegalUI(lang);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("aura_cookie_consent")) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (val) => {
    localStorage.setItem("aura_cookie_consent", val);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 md:inset-x-auto md:end-6 md:bottom-6 md:max-w-md z-[70] rounded-2xl border border-white/15 bg-[#0a0a0a]/95 backdrop-blur-xl p-6 shadow-2xl"
        >
          <div className="flex items-start gap-3 mb-4">
            <Cookie size={20} className="text-white mt-0.5 shrink-0" />
            <div>
              <h3 className="font-display text-base font-semibold text-white">{ui.cookieTitle}</h3>
              <p className="text-sm text-zinc-400 mt-1.5 leading-relaxed">{ui.cookieText}</p>
              <Link to="/cookie" className="text-xs text-zinc-300 underline underline-offset-2 hover:text-white mt-2 inline-block">{ui.cookieMore}</Link>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <button data-testid="cookie-accept" onClick={() => choose("all")} className="flex-1 rounded-full bg-white text-black text-sm font-semibold py-2.5 hover:bg-zinc-200 transition-colors">
              {ui.accept}
            </button>
            <button data-testid="cookie-reject" onClick={() => choose("essential")} className="flex-1 rounded-full border border-white/20 text-zinc-300 text-sm font-medium py-2.5 hover:border-white/40 hover:text-white transition-colors">
              {ui.reject}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
